import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { QuizQuestion, UserAnswerStats } from '@/models/quiz-question.model';

class QuestionsService extends BaseService {
  private url: string = '/api/quiz-question';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<QuizQuestion>> {
    const res = await this.$http.get<QuizQuestion>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }
  public async getStats(id: number): Promise<DataResponse<UserAnswerStats>> {
    const res = await this.$http.get<UserAnswerStats>(
      `/api/user-answer/stats/${id}`,
    );
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<QuizQuestion[]>> {
    const res = await this.$http.get<QuizQuestion[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    item: Partial<QuizQuestion>,
  ): Promise<DataResponse<QuizQuestion>> {
    const res = await this.$http.post<QuizQuestion>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: QuizQuestion): Promise<DataResponse<QuizQuestion>> {
    const res = await this.$http.put<QuizQuestion>(
      `${this.url}/${item.id}`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new QuestionsService();
